module.exports = __webpack_public_path__ + "img/20220624140138.1a1cc4a3.png";